import {
  consentRequestSchema,
  type ConsentDecisionInput,
  type ConsentListQuery,
  type ConsentRequest,
  type Page,
  type RequestConsentInput,
} from '@teentack/shared';
import { post } from '@/lib/api-client';
import { fetchPage } from '@/lib/api-page';

/** The guardian's queue. Parent accounts only. */
export function fetchConsentRequests(
  query: Partial<ConsentListQuery> = {},
): Promise<Page<ConsentRequest>> {
  return fetchPage('/consent/requests', consentRequestSchema, query);
}

/** The teen's own requests and where each stands. */
export function fetchMyConsentRequests(
  query: Partial<ConsentListQuery> = {},
): Promise<Page<ConsentRequest>> {
  return fetchPage('/consent/requests/me', consentRequestSchema, query);
}

export async function requestConsent(input: RequestConsentInput): Promise<ConsentRequest> {
  return consentRequestSchema.parse(await post<unknown>('/consent/requests', input));
}

export async function decideConsent(
  consentId: string,
  input: ConsentDecisionInput,
): Promise<ConsentRequest> {
  return consentRequestSchema.parse(
    await post<unknown>(`/consent/requests/${consentId}/decision`, input),
  );
}
